import { Link } from "react-router-dom";
import { Clock, Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import {
  ADDRESS,
  EMAIL,
  HOURS,
  INSTAGRAM_URL,
  NAV_LINKS,
  WA_MESSAGES,
  WHATSAPP_DISPLAY,
  wa,
  track,
} from "../../data/site";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  const goTo = (e, href) => {
    e.preventDefault();
    scrollToId(href);
  };

  return (
    <footer className="bg-navy text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo light />
            <p className="mt-4 text-sm italic leading-relaxed text-white/60">
              “Higienização e cuidado que transforma”
            </p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-link"
              className="cta-instagram mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:border-aqua hover:text-aqua"
            >
              <Instagram className="h-4 w-4" />
              Instagram
            </a>
          </div>

          <nav aria-label="Navegação do rodapé">
            <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-aqua">
              Navegação
            </h3>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.href.slice(1)}`}
                    onClick={(e) => goTo(e, link.href)}
                    className="text-sm text-white/70 transition-colors hover:text-white"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-aqua">
              Contactos
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li>
                <a
                  href={wa(WA_MESSAGES.contacto)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  data-event="whatsapp_click"
                  onClick={() => track("whatsapp_click", { location: "footer" })}
                  className="cta-whatsapp flex items-center gap-2.5 transition-colors hover:text-white"
                >
                  <MessageCircle className="h-4 w-4 shrink-0 text-aqua" />
                  {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-email"
                  data-event="email_click"
                  onClick={() => track("email_click", { location: "footer" })}
                  className="cta-email flex items-center gap-2.5 transition-colors hover:text-white"
                >
                  <Mail className="h-4 w-4 shrink-0 text-aqua" />
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-aqua" />
                {ADDRESS}
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-aqua">
              Horário
            </h3>
            <p className="mt-4 flex items-start gap-2.5 text-sm text-white/70">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-aqua" />
              {HOURS}
            </p>
            <p className="mt-6 text-sm text-white/50">
              Atendimento ao domicílio em Lisboa e região.
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row">
          <p className="text-xs text-white/50">© 2026 TopEstofos. Todos os direitos reservados.</p>
          <div className="flex flex-wrap justify-center gap-6 text-xs text-white/50">
            <Link
              to="/politica-de-privacidade"
              data-testid="footer-privacy"
              className="transition-colors hover:text-white"
            >
              Política de Privacidade
            </Link>
            <Link
              to="/politica-de-cookies"
              data-testid="footer-cookies"
              className="transition-colors hover:text-white"
            >
              Política de Cookies
            </Link>
            <Link
              to="/termos-e-condicoes"
              data-testid="footer-terms"
              className="transition-colors hover:text-white"
            >
              Termos e Condições
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
